import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-[999] grid h-screen w-screen place-items-center" }
const _hoisted_2 = {
  key: 0,
  class: "bg-mono-ns-100 rounded-3xl w-[295px] xl:w-[569px] flex flex-col p-2 xl:p-4 font-sans gap-6"
}
const _hoisted_3 = {
  key: 0,
  class: "flex flex-row justify-center items-center gap-2 text-mono-ns-200 px-2 xl:px-4"
}
const _hoisted_4 = {
  key: 1,
  class: "flex space-x-2 justify-center items-center px-2 xl:px-4"
}
const _hoisted_5 = { class: "flex flex-col px-2 xl:px-4" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 1,
  class: "bg-mono-ns-100 rounded-3xl flex flex-col p-6 xl:p-10 font-sans items-center gap-4"
}

import {onMounted, ref} from "vue";
import {useStore} from "../store";
import RateStar from "./RateStar.vue";
import IconClose from "./IconClose.vue";
import {useUserStore} from "../store/user";
import {useContentStore} from "../store/content";


export default /*@__PURE__*/_defineComponent({
  __name: 'RateComponent',
  emits: ["toggle"],
  setup(__props, { emit: __emit }) {

const store = useStore()
const contentItem = useContentStore()
const userStore = useUserStore()
const emit = __emit
const btnDisabled = ref<boolean>(true);
const rating = ref(0)
const completed = ref(false)
const loaded = ref(false)

function handleChoice(choice: number): void {
    rating.value = choice
    if (choice !== 0){
        btnDisabled.value = false
    }
}

function onSubmit(){
    btnDisabled.value = true
    completed.value = true
    setTimeout(() => emit('toggle'), 1000)

    store.rateItem(rating.value)
        .then(() => {
            userStore.updateItemRating(contentItem.itemId, rating.value)
        })
}

onMounted(() => {
    userStore.getItemRating(contentItem.itemId)
        .then((data) => {
            loaded.value = true
            rating.value = data
            if (data > 0){
                btnDisabled.value = false
            }
        })
})

function onClose(){
    emit('toggle')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!completed.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "p-2.5 self-end text-mono-ps-200",
            onClick: onClose
          }, [
            _createVNode(IconClose, { "class-name": "w-6 h-6" })
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "text-h3m xl:text-h3 font-bold text-mono-white text-center px-2 xl:px-4 -mt-4" }, "Rate This Show", -1)),
          (loaded.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(RateStar, {
                  rating: 1,
                  full: rating.value >= 1,
                  onChoice: handleChoice
                }, null, 8, ["full"]),
                _createVNode(RateStar, {
                  rating: 2,
                  full: rating.value >= 2,
                  onChoice: handleChoice
                }, null, 8, ["full"]),
                _createVNode(RateStar, {
                  rating: 3,
                  full: rating.value >= 3,
                  onChoice: handleChoice
                }, null, 8, ["full"]),
                _createVNode(RateStar, {
                  rating: 4,
                  full: rating.value >= 4,
                  onChoice: handleChoice
                }, null, 8, ["full"]),
                _createVNode(RateStar, {
                  rating: 5,
                  full: rating.value >= 5,
                  onChoice: handleChoice
                }, null, 8, ["full"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[0] || (_cache[0] = [
                _createElementVNode("span", { class: "sr-only" }, "Loading...", -1),
                _createElementVNode("div", { class: "h-8 w-8 bg-mono-ns-200 rounded-full animate-bounce [animation-delay:-0.3s]" }, null, -1),
                _createElementVNode("div", { class: "h-8 w-8 bg-mono-ns-200 rounded-full animate-bounce [animation-delay:-0.15s]" }, null, -1),
                _createElementVNode("div", { class: "h-8 w-8 bg-mono-ns-200 rounded-full animate-bounce" }, null, -1)
              ]))),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: _normalizeClass(["mb-8 xl:mb-6 font-bold text-center btn rounded-2.4xl xl:rounded-3xl text-mono-ns-200 min-w-fit xl:w-52 w-full relative self-center", {
                        'border-2': btnDisabled.value,
                        'border-mono-ns-200': btnDisabled.value,
                        'bg-mono-white': !btnDisabled.value,
                        'hover:bg-mono-ps-100': !btnDisabled.value,
                        'cursor-not-allowed': btnDisabled.value,
                        'cursor-pointer': !btnDisabled.value,
                    }]),
              disabled: btnDisabled.value,
              onClick: onSubmit
            }, "Rate", 10, _hoisted_6)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[2] || (_cache[2] = [
          _createElementVNode("div", { class: "rounded-full p-3 bg-sa-light text-mono-ns-100" }, [
            _createElementVNode("svg", {
              class: "w-6 h-6",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                d: "M20 6.5L9 17.5L4 12.5",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })
            ])
          ], -1),
          _createElementVNode("h3", null, "Thanks!", -1)
        ])))
  ]))
}
}

})